import { SlideConfig } from '../types';

/**
 * Mapping da slide ID a benefit config key (savingsConfig / useSavingsCalculator)
 */
export const SLIDE_TO_BENEFIT_KEY: Record<string, string> = {
  name_form: 'name_form',
  email_form: 'email_form',
  phone_form: 'phone_form',
};

/**
 * Configurazione delle slide del wizard SliderPapernestShort
 *
 * Slide types:
 * - SINGLE_ANSWER: Selezione singola con griglia di opzioni
 * - FORM_INPUT: Form con input fields
 * - INFO: Slide informativa (loading, success, error)
 */
export const SLIDES_CONFIG: SlideConfig[] = [
  // ============================================
  // SLIDE 1: Form CAP (NO header)
  // ============================================
  {
    id: 'location_form',
    type: 'FORM_INPUT',
    title: "Dove si trova l'immobile in cui installeresti?",
    inputs: [
      {
        name: 'zip',
        placeholder: 'Il tuo CAP',
        type: 'tel',
        required: true,
        pattern: '^\\d{5}$',
      },
    ],
  },

  // ============================================
  // SLIDE 2: Selezione prodotto
  // ============================================
  {
    id: 'customer_type',
    type: 'SINGLE_ANSWER',
    title: 'A quale prodotto sei interessato?',
    apiFieldName: 'product_type',
    autoAdvance: true,
    answers: [
      {
        label: 'Impianto Fotovoltaico',
        value: 'Photovoltaic',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a690341ab4c8ae3331bda7_IT_Slider_Icons_fotovoltaico.svg',
      },
      {
        label: 'Pompa di Calore',
        value: 'Heatpump',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a69034ad376843aacab5d2_IT_Slider_Icons_pompa_di_calore.svg',
      },
      {
        label: 'Fotovoltaico + Pompa di Calore',
        value: 'Photovoltaic + Heatpump',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/6621fcb456e6148dbbc490ee_IT_Slider_Icons_fotovoltaico_con_pompa_di_calore.svg',
      },
    ],
  },

  // ============================================
  // SLIDE 3: Tipo edificio (NO header)
  // ============================================
  {
    id: 'house_type',
    type: 'SINGLE_ANSWER',
    title: 'In quale tipo di edificio deve essere installato l\'impianto?',
    apiFieldName: 'house_type',
    autoAdvance: true,
    answers: [
      {
        label: 'Casa a schiera',
        value: 'townhouse',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a69035fd81055cfcf886db_IT_Slider_Icons_casa_a_schiera.svg',
      },
      {
        label: 'Casa unifamiliare',
        value: 'detached_house',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a690347c3338223a5c8d5d_IT_Slider_Icons_casa_unifamiliare.svg',
      },
      {
        label: 'Palazzina (fino a 6 famiglie)',
        value: 'small_building',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/672101f39fd017299f37df74_IT_Slider_Icons_Copropriet%C3%A0.svg',
      },
      {
        label: 'Condominio (più di 6 famiglie)',
        value: 'multi_family_house',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/672101f43a7562ecc9146c47_IT_Slider_Icons_Condominio.svg',
      },
      {
        label: 'Edificio industriale / Capannone',
        value: 'commercial_building',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a69035e97d173f90bee987_IT_Slider_Icons_edificio_commerciale.svg',
      },
      {
        label: 'Pergolati & Altro',
        value: 'other',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/672101f3dffe24cc4b89bb48_IT_Slider_Icons_Pergolati%20e%20altro.svg',
      },
    ],
  },

  // ============================================
  // SLIDE 4: Timeline installazione (NO header)
  // ============================================
  {
    id: 'install_timeline',
    type: 'SINGLE_ANSWER',
    title: 'Alcuni bonus hanno scadenza limitata, entro quando vorresti installare?',
    apiFieldName: 'purchase_time',
    autoAdvance: true,
    answers: [
      { label: 'Entro 1-2 mesi', value: 'one_to_two_months' },
      { label: 'Entro 3-4 mesi', value: 'three_to_four_months' },
      { label: 'Fra + di 5 mesi', value: 'more_than_5_months' },
      { label: 'Non ho una scadenza precisa', value: 'dont_know' },
    ],
  },

  // ============================================
  // SLIDE 5: Form Nome
  // ============================================
  {
    id: 'name_form',
    type: 'FORM_INPUT',
    title: 'Inserisci i tuoi dati per ricevere un preventivo personalizzato',
    inputs: [
      {
        name: 'name',
        placeholder: 'Nome e cognome',
        type: 'text',
        required: true,
      },
    ],
  },

  // ============================================
  // SLIDE 6: Form Email
  // ============================================
  {
    id: 'email_form',
    type: 'FORM_INPUT',
    title: 'Inserisci i tuoi dati per ricevere un preventivo personalizzato',
    inputs: [
      {
        name: 'email',
        placeholder: 'Il tuo indirizzo email',
        type: 'email',
        required: true,
      },
    ],
  },

  // ============================================
  // SLIDE 7: Form Telefono
  // ============================================
  {
    id: 'phone_form',
    type: 'FORM_INPUT',
    title: 'A che numero possiamo contattarti nei prossimi 15 minuti?',
    inputs: [
      {
        name: 'phone',
        placeholder: 'Numero di cellulare',
        type: 'tel',
        required: true,
        pattern: '^[\\d\\s]{10,18}$',
      },
    ],
  },

  // ============================================
  // SLIDE 8: Loading
  // ============================================
  {
    id: 'loading',
    type: 'INFO',
    title: 'Invio della richiesta in corso...',
    html: '<p>Attendere prego...</p><img src="https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca.gif" alt="Loading..." style="margin-top:1rem;max-width:80px;border-radius:10px;">',
  },

  // ============================================
  // SLIDE 9: Success
  // ============================================
  {
    id: 'success',
    type: 'INFO',
    title: '',
  },

  // ============================================
  // SLIDE 10: Error
  // ============================================
  {
    id: 'error',
    type: 'INFO',
    title: 'Oops, qualcosa è andato storto',
    html: '<p>Si è verificato un errore...</p>',
  },
];

/**
 * Trova l'indice di una slide per ID
 */
export const getSlideIndexById = (id: string): number => {
  return SLIDES_CONFIG.findIndex((slide) => slide.id === id);
};

/**
 * Slide IDs legate al calcolo benefici (savingsConfig)
 */
export const BENEFIT_SLIDE_IDS = ['name_form', 'email_form', 'phone_form'] as const;

/**
 * Slide IDs per il calcolo del progresso
 */
export const PROGRESS_SLIDE_IDS = SLIDES_CONFIG
  .filter((slide) => slide.type === 'SINGLE_ANSWER' || slide.type === 'FORM_INPUT')
  .map((slide) => slide.id);

/**
 * Ottiene la chiave del beneficio per un dato slide ID
 */
export function getBenefitKeyForSlide(slideId: string): string {
  return SLIDE_TO_BENEFIT_KEY[slideId] || slideId;
}
